/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Exercise_PlaceholderInputs */

const fr_leaderboard_exercise_placeholder = /** @type {(inputs: Leaderboard_Exercise_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un exercice...`)
};

/**

* @param {Leaderboard_Exercise_PlaceholderInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_exercise_placeholder = /** @type {((inputs?: Leaderboard_Exercise_PlaceholderInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Exercise_PlaceholderInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_exercise_placeholder(inputs)
});